import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../Context/AuthProvider';
import { loginItemsSelector, setUserDetails } from '../../redux/slices/login';
import { useDispatch, useSelector } from 'react-redux';
import Logo from '../../Asset/image/tamara_logo.png';
import GoogleLoginButton from '../../Asset/image/google.png';
import { useGoogleLogin } from '@react-oauth/google';
import sideImage from '../../Asset/image/header-img.png';
import eyeIcon from '../../Asset/image/041-eye.png';
import closedEyeIcon from '../../Asset/image/closed-eye-icon-2.png';
import emailIcon from '../../Asset/image/email.png';
import passwordIcon from '../../Asset/image/password.png';
import { loginUser } from '../../services/loginService';
import { Button, Col, Container, Form, FormLabel, Image, InputGroup, Row } from 'react-bootstrap';
import CustomImage from '../../CommonComponents/CustomImage';
import CustomLine from '../../CommonComponents/CustomLine';
import { toast } from 'react-toastify';
import { forgotPasswordService, loginService } from '../../services/userService';
import { isEmpty, signUpType } from '../../data/constants';
import axios from 'axios';
import { isValiEmail } from '../../lib/helper';

const LoginForm = () => {
    /* @ts-ignore */
    const { user, login, socialLogin } = useAuth();
    const [validated, setValidated] = useState(false);
    const [state, setState] = useState({
        email: '',
        password: '',
        isSecureTextEntry: true,
    });
    const [type, setType] = useState('password');
    const [icon, setIcon] = useState(false);
    const allUserState = useSelector(loginItemsSelector);
    const dispatch = useDispatch();
    const [error, setError] = useState({ email: false });

    const navigate = useNavigate();
    useEffect(() => {
        if (user) {
            dispatch(setUserDetails(user))
            navigate('/app/user-dashboard', { replace: true });
        }
    }, [user]);
    const handlePassView = () => {
        if (type === 'password') {
            setIcon(true);
            setType('text');
        } else {
            setIcon(false);
            setType('password');
        }
    }
    const loginAsGuest = async () => {
        const gUser = {
            "_id": "guest_12",
            "email": "guest@tamara.com",
            "name": "Guest",
            "signuptype": signUpType.guest,
            "dob": new Date(),
            "gender": "guest",
            "mobileNo": "999999999",
            "profilePicture": ""
        }
        login(gUser);
        dispatch(setUserDetails(gUser));
    };
    const handleLogin = () => {
        try {
            const payload = {
                "password": state.password,
                "email": state.email,
                subscribed: 'true',
            };
            /* @ts-ignore */
            dispatch(loginUser(payload, login))
        } catch (e) {
            console.log(e, 'error');
        }
    };
    const renderError = (msg, value, style) => {
        return (
            value ? (
                <h6 className="blog_error_text4 signUpMsg12" style={{ marginBottom: 10, marginTop: style !== undefined ? 10 : -10 }}>
                    {msg}
                </h6>) : null)
    }
    const handleSubmit = (event) => {
        const form = event.currentTarget;
        event.preventDefault();
        event.stopPropagation();
        if (form.checkValidity() === false) {
            setValidated(false);
        } else {
            if (!isValiEmail(state.email)) {
                setError({ ...error, email: true })
            }
            else
                handleLogin()
        }
        setValidated(true);
    };
    const onGoogleButton = (userr) => {
        if (userr) {
            axios
                .get(`https://www.googleapis.com/oauth2/v1/userinfo?access_token=${userr.access_token}`, {
                    headers: {
                        Authorization: `Bearer ${userr.access_token}`,
                        Accept: 'application/json'
                    }
                })
                .then((res) => {
                    const params = {
                        name: res?.data?.name,
                        email: res?.data?.email,
                        photo: res?.data?.picture ? res?.data?.picture : '',
                        signupfrom: signUpType.google,
                        // subscribed: 'true',
                    };
                    socialLogin(params);
                })
                .catch((err) => console.log(err));
        }
    }
    const loginn = useGoogleLogin({
        onSuccess: (codeResponse) => onGoogleButton(codeResponse),
        onError: (error) => console.log('Login Failed:', error)
    });
    return (
        <>
            <div className="main-login-page backgroundColor" style={{ backgroundColor: " #060B19" }}>
                <Container fluid className="login-div">
                    <div className="login-container">
                        <CustomImage className="logo_style" src={Logo} />
                        <h2 className="App-header">Log In</h2>
                        <p className="sub-header">Welcome! Please enter your email and password.</p>
                        <Form noValidate validated={validated} onSubmit={handleSubmit} >
                            <Row className='d-flex justify-content-center'>
                                <Form.Group as={Row} controlId="validationCustom01">
                                    <div className="wrapper ">
                                        <CustomImage className="icon" src={emailIcon} />
                                        <Form.Control
                                            required
                                            type="email"
                                            placeholder="Email Address"
                                            className="input-box px-5"
                                            defaultValue="Test@yopmail.com"
                                            value={state.email}
                                            onChange={(e) => { setState({ ...state, email: e.target.value }); setError({ ...error, email: false }) }}
                                        />
                                        <Form.Control.Feedback type="invalid">Please enter email!</Form.Control.Feedback>
                                    </div>
                                </Form.Group>
                                {error.email ? renderError('Please enter valid email', true, false) : null}
                                <Form.Group as={Row} controlId="validationCustom02">
                                    <div className="wrapper">
                                        <CustomImage className="icon" src={passwordIcon} />
                                        <Form.Control
                                            required
                                            type={type}
                                            placeholder="Password"
                                            className="input-box px-5"
                                            defaultValue="Test@123"
                                            value={state.password}
                                            onChange={(e) => setState({ ...state, password: e.target.value })}
                                        />
                                        <CustomImage className="iconRight" src={type == "text" ? closedEyeIcon : eyeIcon} onClick={handlePassView} />

                                        <Form.Control.Feedback type="invalid">Please enter password!</Form.Control.Feedback>
                                    </div>
                                </Form.Group>
                                <div className="form-item">
                                    <div onClick={() => {
                                        navigate('/app/forgotemail')
                                    }} className="form-link d-flex justify-content-end pe-4 mt-2 pointerData">Forgot Password</div>
                                </div>


                                <Button type='submit' className='login_button mt-4' disabled={allUserState?.user?.loading}>
                                    {allUserState?.user?.loading ? (
                                        <div className='d-flex justify-content-center'>
                                            <center>
                                                <div
                                                    style={{ width: "1rem", height: "1rem", color: "#1f7e78" }}
                                                    class="spinner-border me-3"
                                                    role="status"
                                                />
                                            </center>Log In
                                        </div>) : "Log In"}
                                </Button>
                            </Row>
                            <div className="d-flex justify-content-center mt-4">
                                <p className='text-label'>Don't have an account? &nbsp;
                                    <Link to="/app/create-account" className="create-link pe-4"> Create Account</Link></p>
                            </div>
                            <CustomLine txt="Or" />
                            <div className="d-flex justify-content-center mt-4">
                                <CustomImage className="social_button" src={GoogleLoginButton} onClick={() => loginn()} />
                            </div>
                            <CustomLine txt="Or" />
                            <div className="d-flex justify-content-center mt-4">
                                <p className='text-label'>Login as a &nbsp; </p>
                                <Link to="" className="create-link pe-4" onClick={loginAsGuest}> Guest User</Link>
                            </div>
                        </Form>
                    </div>
                    <div className="d-none d-lg-block" style={{
                        position: "absolute",
                        zIndex: 0,
                        height: '100vh',
                        width: '75vw',
                        right: 0
                    }}>
                        <CustomImage className="w-100" src={sideImage} />
                    </div>
                </Container>
            </div >
        </>
    );
};

export default LoginForm;
